module.exports = __webpack_public_path__ + "static/media/laioffer-course-5.80db1e45.jpg";